import Note from './Note.js'

const HeaderParameterTable = (props) => {
    if(Array.isArray(props.header) === false || props.header.length === 0){
        return <Note>No parameters required</Note>
    }
    return(
        <table className="parameter-table" style={props.style}>
                <thead>
                    <tr>
                        <th>Key</th>
                        <th>Value</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                {props.header.map((reqData, i)=>(
                    <tr key={i}>
                        <td><code>{reqData.key}</code></td>
                        <td><code>{reqData.value}</code></td>
                        <td><code>{reqData.type}</code></td>
                    </tr>
                ))}
                </tbody>
                </table>
    )
}
export default HeaderParameterTable